/**
 * Converts a date string to dd/mm/yy format using Intl.DateTimeFormat
 * @param {string} dateString - Date string in format "YYYY-MM-DD HH:MM:SS"
 * @returns {string} Date in format "dd/mm/yy"
 */
export function formatDateWithIntl(dateString: Date | string): string {
  const date = new Date(dateString);

  const formatter = new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
  });

  return formatter.format(date);
}
